import Axios from 'axios'
import store from '@/store'
// import {message} from "ant-design-vue";

// 默认 axios 实例请求配置
const configDefault = {
    // headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    // },
    timeout: 20000,
    baseURL: 'https://gumizt.sdwlwl.cn/api',
    data: {},
}

class Http {
    constructor(config) {
        Http.axiosConfigDefault = config
        Http.axiosInstance = Axios.create(config)
        this.httpInterceptorsRequest()
        this.httpInterceptorsResponse()
    }
    // 当前实例
    static axiosInstance
    // 请求配置
    static axiosConfigDefault

    // 请求拦截
    httpInterceptorsRequest() {
        Http.axiosInstance.interceptors.request.use(
            (config) => {
                // 发送请求前，可在此携带 token
                // if (store.state.user.userInfo.token) {
                //   config.headers['token'] = store.state.user.userInfo.token
                // }
                return config
            },
            (error) => {
                // showFailToast(error.message);
                return Promise.reject(error)
            }
        )
    }

    // 响应拦截
    httpInterceptorsResponse() {
        Http.axiosInstance.interceptors.response.use(
            (response) => {
                return response.data
            },
            (error) => {
                console.log(error)
                return Promise.reject(error)
            }
        )
    }

    // 通用请求函数
    request(paramConfig) {
        const config = { ...Http.axiosConfigDefault, ...paramConfig }
        return new Promise((resolve, reject) => {
            Http.axiosInstance
                .request(config)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}

export const http = new Http(configDefault)
